import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TeamTypeConfiguration } from "@common/ADAPT.Common.Model/organisation/team-type-configuration";

@Component({
    selector: "adapt-display-team-type",
    templateUrl: "./display-team-type.component.html",
    styleUrl: "./display-team-type.component.scss",
    imports: [NgClass],
})
export class DisplayTeamTypeComponent {
    @Input({ required: true }) public teamTypeConfiguration!: TeamTypeConfiguration;
    @Input() public showName = false;
}
